


























































































import { Vue, Component } from 'vue-property-decorator'
import * as utils from '@ivy/fts/utils'
import { env } from '@ivy/fts/envInfo/envInfo'
import ProgressBar from '../comps/process-bar.vue'
import { requireGet, requirePost, addStatistics } from '../require'
@Component({
  components: {
    ProgressBar,
  },
})
export default class Test extends Vue {
  screenHeight: any = document.documentElement.clientHeight
  originHeight: any = document.documentElement.clientHeight
  topSuffix = require('../imgs/top-suffix.png')
  originList: any = []
  questionList: any = []
  currentIndex: number = 0
  activityId: any = ''
  hasLogined: boolean = false
  processLength: number = 0
  ios10Shadow: boolean = false
  get buttonText() {
    return this.currentIndex < this.questionList.length - 1 ? '下一题' : '提交'
  }
  get isChoosed() {
    return (
      !this.questionList ||
      !this.questionList[this.currentIndex] ||
      !this.questionList[this.currentIndex].selectedIdList ||
      !this.questionList[this.currentIndex].selectedIdList.length
    )
  }
  async isLogined() {
    let isLogin = await env.getIsLogin()
    this.hasLogined = isLogin
    if (!isLogin) {
      this.ios10Shadow = true
      return await env.login(this.afterLogin)
    }
  }
  async afterLogin() {
    if (!this.activityId) {
      return this.$Toast('问卷不存在～')
    }
    const { data: activityInfo } = await requireGet(
      `/api/activity/appActivity/typeTestActivity/getQuestionActivity?activity_id=${
        this.$route.query.activityId
      }`
    )
    this.questionList = []
    this.originList =
      activityInfo.questionList &&
      activityInfo.questionList.map(item => {
        let relationId =
          (item.rule &&
            item.rule.relate_question &&
            item.rule.relate_question) ||
          ''
        let relateOption =
          (item.rule && item.rule.relate_option && item.rule.relate_option) ||
          []
        return {
          ...item,
          relationId,
          relateOption,
          subText: '',
        }
      })
    this.questionList = this.originList.filter(item => {
      return !item.relationId
    })
    this.processLength = this.questionList.length
  }
  async ios10ShadowClick() {
    window.location.reload()
  }
  async created() {
    this.activityId = this.$route.query.activityId
    await env.init()
    await this.isLogined()
    if (!this.hasLogined) return
    this.afterLogin()
  }
  mounted() {
    let scrollList: any = this.$refs.scrollList
    scrollList &&
      scrollList.style &&
      (scrollList.style.transform = `translateX(${-this.currentIndex * 100}vw)`)
    window.onresize = () =>
      (() => {
        this.screenHeight = document.documentElement.clientHeight
      })()
    // 阻止tab 键切换导致显示异常
    window.addEventListener('keydown', event => {
      if (event.keyCode === 9) {
        event.preventDefault()
      }
    })
  }
  async handlerSelect(item, index, opt, oIndex) {
    let oiIndex = this.originList.findIndex(oi => oi.id === item.id)
    if (item.type === 1) {
      let arr = [opt.id]
      this.$set(this.originList[oiIndex], 'selectedIdList', arr)
    } else if (item.type === 2) {
      let arr = this.originList[oiIndex].selectedIdList || []
      let curIndex = arr.findIndex(el => el === opt.id)
      if (curIndex !== -1) {
        arr.splice(curIndex, 1)
      } else {
        arr.push(opt.id)
      }
      this.$set(this.originList[oiIndex], 'selectedIdList', arr)
    }
    this.questionList = this.originList.filter((ori, iiIndex) => {
      if (!ori.relationId || iiIndex === oiIndex) return true
      let hhIndex = this.originList.findIndex(hh => +hh.id === +ori.relationId)
      if (hhIndex === -1) return false
      let seleList = this.originList[hhIndex]
      let relateOption = ori.relateOption || []
      if (
        !seleList.selectedIdList ||
        !seleList.selectedIdList.length ||
        !relateOption ||
        !relateOption.length
      )
        return false
      let flag = false
      for (let id of seleList.selectedIdList) {
        if (relateOption.findIndex(rel => rel === id) !== -1) {
          flag = true
          break
        }
      }
      if (!flag) {
        if (ori.type === 3) {
          this.$set(this.originList[iiIndex], 'subText', '')
        } else {
          this.$set(this.originList[iiIndex], 'selectedIdList', [])
        }
      }
      return flag
    })
  }
  checkSelected(item, opt) {
    if (item.selectedIdList && item.selectedIdList.length) {
      let index = item.selectedIdList.findIndex(el => el === opt.id)
      if (index !== -1) return true
      return false
    }
    return false
  }
  changeContent(item, index) {
    if (item.subText.trim() !== '') {
      let arr = [1]
      this.$set(this.questionList[index], 'selectedIdList', arr)
    } else {
      this.$set(this.questionList[index], 'selectedIdList', null)
    }
  }
  getContentLen(content) {
    return content.length
  }
  async goNext() {
    if (
      !this.questionList[this.currentIndex].selectedIdList ||
      !this.questionList[this.currentIndex].selectedIdList.length
    )
      return
    if (this.currentIndex < this.questionList.length - 1) {
      this.currentIndex++
    } else if (this.currentIndex === this.questionList.length - 1) {
      // 提交后跳转提交成功页面
      let result = this.questionList.map(item => {
        return {
          question: item.id,
          content: item.type === 3 ? item.subText : item.selectedIdList,
        }
      })
      const { data: saveInfo } = await requirePost(
        '/api/activity/appActivity/typeTestActivity/saveQuestionRecord',
        {
          activity_id: this.activityId,
          result,
        }
      )
      if (saveInfo.code) {
        return this.$Toast(saveInfo.message)
      }
      this.$router.replace({
        path: '/questionnaire/reportPage',
        query: {
          activityId: this.activityId,
        },
      })
    }
    this.processLength = this.questionList.length
  }
  goPre() {
    if (this.currentIndex > 0) {
      this.currentIndex--
      this.processLength = this.questionList.length
    }
  }
  destroyed() {
    window.removeEventListener('keydown', event => {
      event.preventDefault()
    })
  }
}
